import { render, staticRenderFns } from "./px-footer.vue?vue&type=template&id=199c24f8&"
import script from "./px-footer.vue?vue&type=script&lang=ts&"
export * from "./px-footer.vue?vue&type=script&lang=ts&"
import style0 from "./px-footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports